module.exports = __webpack_public_path__ + "static/media/email.dadd57c8.svg";